import _ from 'lodash'
import { FETCH_USER_PORTALS_CUSTOMER_GROUPS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_USER_PORTALS_CUSTOMER_GROUPS:
      return action.payload
    default:
      return state
  }
}
